import React from 'react';
import styles from './PricingCard.module.scss';

const formatPrice = (value) => new Intl.NumberFormat('en-US').format(value);

const PricingCard = ({ pkg, isLoading, onCtaClick }) => {
    const price = pkg?.price_vnd ?? 1050000;
    const currency = pkg?.currency_vnd_label ?? 'VND';
    const note = pkg?.description ?? 'One time payment — full access';
    const benefits = Array.isArray(pkg?.features)
        ? pkg.features
        : [
            'Lock in current price for Early Access duration and get exclusive deal at launch',
            'Access all future builds automatically (no extra fees)',
            '14-day money-back guarantee',
            'Influence which features we build next',
        ];

    return (
        <section className={styles.section}>
            <div className={styles.card}>
                {/* EARLY ACCESS corner ribbon */}
                <div className={styles.ribbon} aria-label="Early Access">
                    <span>EARLY ACCESS</span>
                </div>

                {/* Badge */}
                <div className={styles.badge}>
                    <span className={styles.pulseDot} aria-hidden="true" />
                    <span>LOCK IN WITH FOUNDING MEMBER PRICE</span>
                </div>

                {/* Price */}
                {isLoading ? (
                    <div className={styles.skeleton} aria-busy="true" />
                ) : (
                    <>
                        <div className={styles.priceBlock}>
                            <span className={styles.price}>{formatPrice(price)}</span>
                            <span className={styles.currency}>&nbsp;{currency}</span>
                        </div>
                        <p className={styles.priceNote}>{note}</p>
                    </>
                )}

                <hr className={styles.divider} />

                {/* Benefits */}
                <ul className={styles.benefitsList} aria-label="Included benefits">
                    {benefits.map((b, i) => (
                        <li key={i} className={styles.benefitItem}>
                            <span className={styles.check} aria-hidden="true">✓</span>
                            {b}
                        </li>
                    ))}
                </ul>

                {/* CTA */}
                <button className={styles.ctaBtn} onClick={onCtaClick}>
                    Start Practicing Today
                </button>

                <p className={styles.footerNote}>Money-back guarantee. Secure payment.</p>
            </div>
        </section>
    );
};

export default PricingCard;
